import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { CustomerVisits, Website } from "@/api/types"

export function topCustomersOptions(website: Website, days: number) {
	return queryOptions({
		queryKey: ["analytics", website, "top-customers", days],
		queryFn: (): Promise<CustomerVisits[]> =>
			GET("/api/v1/analytics/{website}/top-customers", {
				params: { path: { website }, query: { days } },
			}),
	})
}

export function useTopCustomers(website: Website, days: number) {
	return useQuery(topCustomersOptions(website, days))
}
